__turbopack_context__.v({
  "banner": "Banners-module-scss-module___sIkhW__banner",
  "banner_mobile": "Banners-module-scss-module___sIkhW__banner_mobile",
  "banners": "Banners-module-scss-module___sIkhW__banners",
  "chevron-right-stroke": "Banners-module-scss-module___sIkhW__chevron-right-stroke",
  "content": "Banners-module-scss-module___sIkhW__content",
  "image": "Banners-module-scss-module___sIkhW__image",
  "linkBtn": "Banners-module-scss-module___sIkhW__linkBtn",
  "linkBtnForAppStoreAndPlayMarket": "Banners-module-scss-module___sIkhW__linkBtnForAppStoreAndPlayMarket",
  "linkButtonsWrapper": "Banners-module-scss-module___sIkhW__linkButtonsWrapper",
  "text": "Banners-module-scss-module___sIkhW__text",
  "text_main": "Banners-module-scss-module___sIkhW__text_main",
  "text_secondary": "Banners-module-scss-module___sIkhW__text_secondary",
});
